import React, {useContext} from 'react';
import {SectionsContext} from "../contexts/SectionsProvider";
import {MortgageContext} from "../contexts/MortgageProvider";
import Menu from "../ui/outlet-views/Menu";

function ApplyMenu(props) {
    //const context = useContext(ApplySectionContext)
    const mortgageContext = useContext(MortgageContext)
    const sectionsContext = useContext(SectionsContext)
    const getSectionProgress = (name) => {
        let section = sectionsContext.sections.apply.find(i=>i.name===name)
        return section.progress
    }
    const getApplicantProgress=(applicant)=>{
        let k= 'applicant'+applicant
        let sections = sectionsContext.sections.apply.filter(i=>i.applicant === applicant)
        let vals = sections.map(i=>i.progress)
        let sum = vals.reduce((partialSum, a) => partialSum + a, 0);
        let avg = Math.floor(sum / vals.length)
        return avg
    }

    const items = [
        {
            title: 'The property',
            link: 'property',
            progress: getSectionProgress('property'),
        }
    ]
    if (mortgageContext.mortgage.mortgageType === 'PURCHASE') {
        items.push({
            title: 'Source of deposit',
            progress: getSectionProgress('deposit'),
            link: 'deposit',
        })
    }
    if (mortgageContext.mortgage.mortgageType === 'REFINANCE') {
        items.push({
            title: 'Current Mortgage',
            progress: getSectionProgress('existing'),
            link: 'existing',
        })
    }
    items.push({
        title: 'Mortgage needs',
        progress: getSectionProgress('needs'),
        link: 'needs',
    })
    items.push({
        title: 'Your details',
        link: '/apply-1',
        progress: getApplicantProgress(1),
    })
    if (mortgageContext.mortgage.twoApplicants) {
        let name = mortgageContext.mortgage.applicant2.firstName || 'The other applicant'
        items.push({
            title: `${name}'s details`,
            link: '/apply-2',
            progress: getApplicantProgress(2),
        })
    }



    return <Menu
        title={'Provide your information'}
        back={'/'}
        progress={0}
        items={items}

    >

    </Menu>
}
export default ApplyMenu;